import comp from "./CommentPane";
export default comp;
